var transactionDisputeStatusTitle = {
    actionRequested: 'Información adicional solicitada',
    cancelationProcessing: 'Estamos procesando la cancelación de la solicitud',
    disputeApproved: 'Su disputa fue aprobada',
    disputeCanceled: 'Su disputa fue cancelada',
    disputeCompleted: 'Su disputa fue completada',
    disputeDenied: 'Su disputa fue denegada',
    new: 'Se ha abierto su disputa',
    temporaryCredit: 'Aplicamos un crédito temporal',
    underReview: 'Su disputa está bajo revisión'
};
export default transactionDisputeStatusTitle;
//# sourceMappingURL=transactionDisputeStatusTitle.js.map